<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new supplier</small>
      </legend>
      <div>
        <form @submit.prevent="newSupplier()">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Supplier name</label>
                <input
                  type="text"
                  class="form-control supplier_name"
                  placeholder="supplier name"
                  required
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Contact person</label>
                <input
                  type="text"
                  class="form-control contact_person"
                  placeholder="contact person"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Phone number</label>
                <input
                  type="text"
                  class="form-control phone_number"
                  placeholder="phone number"
                />
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary btn-flat creatingSupplier btn-rounded"
          >
            <i class="fa fa-truck"></i>  Add Supplier
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat creatingSupplierLoader btn-rounded"
          >
            <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>please
            wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  methods: {
    ...mapActions(["newSupplier"]),
  },
};
</script>
<style scoped>
.creatingSupplierLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/suppliers/supplier.vue